export const API_LINK = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_LIMIT = 10;
export const ITEMS_PER_PAGE = 10;
export const API_KEY = `d9dfe233-cf74-4fca-a7ae-6df374de33d8`;
export const SUCCESS_MSG_TIME = 1.5;
export const SPINNER_TIME = 0.5;
